import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addNewQuoteStatus,
  addNewQuoteStatusSuccess,
  deleteQuoteStatus,
  deleteQuoteStatusSuccess,
  updateQuoteStatus,
  updateQuoteStatusSuccess,
} from "../../../../store/quote/action";
import {
  createLiabilityItemCategory,
  createLiabilityItemCategorySuccess,
  createLiabilityStatus,
  createLiabilityStatusSuccess,
  deleteLiabilityItemCategory,
  deleteLiabilityItemCategorySuccess,
  deleteLiabilityStatus,
  deleteLiabilityStatusSuccess,
  getLiabilityItemCategoryList,
  getLiabilityStatusList,
  updateLiabilityItemCategory,
  updateLiabilityItemCategorySuccess,
  updateLiabilityStatus,
  updateLiabilityStatusSuccess,
} from "../../../../store/Liability/action";
export default function LiabilitySettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const { liabilityStatusListAPI, liabilityItemCategoryListAPI } = useSelector(
    (state) => ({
      liabilityStatusListAPI:
        state.Liability.liabilityStatusList?.liabilitystatus_list,
      liabilityItemCategoryListAPI:
        state.Liability.liabilityItemCategoryList?.liabilityitemcategory_list,
    })
  );
  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(createLiabilityStatus([createStatus]));
    }
    if (activeTab === "2") {
      //   Status create
      dispatch(createLiabilityItemCategory([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = liabilityStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = liabilityItemCategoryListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [liabilityStatusListAPI, liabilityItemCategoryListAPI, activeTab]);

  useEffect(() => {
    dispatch(getLiabilityStatusList());
    dispatch(getLiabilityItemCategoryList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Statuses",
    },
    {
      id: "2",
      name: "Item Category",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteLiabilityStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      //   Status delete
      dispatch(deleteLiabilityItemCategory([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateLiabilityStatus([updateNewStatus]));
      }
      if (activeTab === "2") {
        //  Status update
        dispatch(updateLiabilityItemCategory([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Success API
  const {
    createLiabilityStatusSuccessAPI,
    deleteLiabilityStatusSuccessAPI,
    updateLiabilityStatusSuccessAPI,
    createLiabilityItemCategorySuccessAPI,
    deleteLiabilityItemCategorySuccessAPI,
    updateLiabilityItemCategorySuccessAPI,
  } = useSelector((state) => ({
    createLiabilityStatusSuccessAPI:
      state.Liability.createLiabilityStatusSuccess,
    deleteLiabilityStatusSuccessAPI:
      state.Liability.deleteLiabilityStatusSuccess,
    updateLiabilityStatusSuccessAPI:
      state.Liability.updateLiabilityStatusSuccess,
    createLiabilityItemCategorySuccessAPI:
      state.Liability.createLiabilityItemCategorySuccess,
    deleteLiabilityItemCategorySuccessAPI:
      state.Liability.deleteLiabilityItemCategorySuccess,
    updateLiabilityItemCategorySuccessAPI:
      state.Liability.updateLiabilityItemCategorySuccess,
  }));
  // Add new Status
  useEffect(() => {
    if (isEmpty(createLiabilityStatusSuccessAPI)) return;
    if (createLiabilityStatusSuccessAPI.status === 200) {
      toast.success(createLiabilityStatusSuccessAPI?.message);
      dispatch(getLiabilityStatusList());
    } else {
      toast.error(createLiabilityStatusSuccessAPI?.message);
    }
    dispatch(createLiabilityStatusSuccess([]));
  }, [createLiabilityStatusSuccessAPI]);

  // Delete Status
  useEffect(() => {
    if (isEmpty(deleteLiabilityStatusSuccessAPI)) return;
    if (deleteLiabilityStatusSuccessAPI.status === 200) {
      toast.success(deleteLiabilityStatusSuccessAPI?.message);
      dispatch(getLiabilityStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deleteLiabilityStatusSuccessAPI?.message);
    }
    dispatch(deleteLiabilityStatusSuccess([]));
  }, [deleteLiabilityStatusSuccessAPI]);

  // Update Status
  useEffect(() => {
    if (isEmpty(updateLiabilityStatusSuccessAPI)) return;
    if (updateLiabilityStatusSuccessAPI.status === 200) {
      toast.success(updateLiabilityStatusSuccessAPI?.message);
      dispatch(getLiabilityStatusList());
    } else {
      toast.error(updateLiabilityStatusSuccessAPI?.message);
    }
    dispatch(updateLiabilityStatusSuccess([]));
  }, [updateLiabilityStatusSuccessAPI]);

  // Add new Item Category
  useEffect(() => {
    if (isEmpty(createLiabilityItemCategorySuccessAPI)) return;
    if (createLiabilityItemCategorySuccessAPI.status === 200) {
      toast.success(createLiabilityItemCategorySuccessAPI?.message);
      dispatch(getLiabilityItemCategoryList());
    } else {
      toast.error(createLiabilityItemCategorySuccessAPI?.message);
    }
    dispatch(createLiabilityItemCategorySuccess([]));
  }, [createLiabilityItemCategorySuccessAPI]);

  // Delete Item Category
  useEffect(() => {
    if (isEmpty(deleteLiabilityItemCategorySuccessAPI)) return;
    if (deleteLiabilityItemCategorySuccessAPI.status === 200) {
      toast.success(deleteLiabilityItemCategorySuccessAPI?.message);
      dispatch(getLiabilityItemCategoryList());
      setDeleteModal(false);
    } else {
      toast.error(deleteLiabilityItemCategorySuccessAPI?.message);
    }
    dispatch(deleteLiabilityItemCategorySuccess([]));
  }, [deleteLiabilityItemCategorySuccessAPI]);

  // Update Item Category
  useEffect(() => {
    if (isEmpty(updateLiabilityItemCategorySuccessAPI)) return;
    if (updateLiabilityItemCategorySuccessAPI.status === 200) {
      toast.success(updateLiabilityItemCategorySuccessAPI?.message);
      dispatch(getLiabilityItemCategoryList());
    } else {
      toast.error(updateLiabilityItemCategorySuccessAPI?.message);
    }
    dispatch(updateLiabilityItemCategorySuccess([]));
  }, [updateLiabilityItemCategorySuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Liability Settings"
        description="Statuses and item categories for liabilities."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
        />
      </SettingsPanel>
    </>
  );
}
